export const sliderBreakpoints = {
  1800: { slidesPerView: 5 },
  1440: { slidesPerView: 4 },
  1024: { slidesPerView: 3 },
  960: { slidesPerView: 2 },
  720: { slidesPerView: 2 },
  500: { slidesPerView: 1 },
  320: { slidesPerView: 1 },
} as const;

export function getCurrentSlidesPerView(): number {
  const width = window.innerWidth;

  return (
    (Object.entries(sliderBreakpoints) as [string, { slidesPerView: number }][])
      .sort(([a], [b]) => Number(b) - Number(a))
      .find(([bp]) => width >= Number(bp))?.[1].slidesPerView ?? 1
  );
}
